import { createMuiTheme } from "@material-ui/core/styles";

export const YELLOW = "#F9CA24";
export const GREEN = "#1B7E78";
export const GREEN_DOWN = "#176F6A";
export const BLUE = "#0E0C83";
export const GRAY = "#E5E5E5";
export const GRAY_DOWN = "#D8D8D8";
export const BLACK = "#000C2D";
export const WHITE = "#fff";

export const DEFAULT_BORDER = "1px solid #000";

export const getColWidth = (n = 1, type = "vw") => `${(100 / 24) * n}${type}`;

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      main: GREEN
    },
    common: {
      black: BLACK,
      white: WHITE,
      yellow: YELLOW,
      green: GREEN,
      greenDown: GREEN_DOWN,
      blue: BLUE,
      gray: GRAY,
      grayDown: GRAY_DOWN
    },
    background: {
      default: WHITE
    }
  }
});

// console.log(theme);

export default theme;
